module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (261).155af547.jpg";